module.exports = __webpack_public_path__ + "assets/img/zysh.c044ed2e.png";